<template>
  <ul :class="{ snsShareBtn: 'snsShareBtn' === ulClassName, detailePageSnsShareBtn: 'detailePageSnsShareBtn' === ulClassName, portfolioSnsShareBtn: 'portfolioSnsShareBtn' === ulClassName }">
    <li class="shareTxt">{{ message ? message : 'このページをシェアする' }}</li>
    <li class="twBtn"><a :href="`https://twitter.com/share?url=${shareUrl}&text=${shareTitle}`" target="_blank" rel="noopener noreferrer" @click="logger('twitter')"><img class="" src="/img/snsTw.png" srcset="/img/snsTw@2x.png 2x" alt="Twitter" /></a></li>
    <li class="fbBtn"><a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`" target="_blank" rel="noopener noreferrer" @click="logger('facebook')"><img class="" src="/img/snsFb.png" srcset="/img/snsFb@2x.png 2x" alt="facebook" /></a></li>
  </ul>
</template>

<script>

export default {
  props: [
    'message',
    'ulClassName'
  ],
  data () {
    return {
      currentUrl: '',
      title: ''
    }
  },
  computed: {
    shareUrl () {
      return encodeURI(this.currentUrl)
    },
    shareTitle () {
      return encodeURI(this.title)
    }
  },
  watch: {
    // URLの変更を監視し、変更時にSNSシェア情報を追従させる
    '$route.path': function () {
      this.currentUrl = location.href
      this.title = document.title
    }
  },
  methods: {
    logger (snsType) {
      // イベント記録
      this.$ga.event('SnsShare', snsType, location.href, null)
    }
  },
  mounted () {
    this.currentUrl = location.href
    this.title = document.title
  }
}
</script>
